<template>
  <div class="container">
    <div class="visit-page trans">
      <down-header
        :headerConfig="headerConfig"
        @handleClickIocn="handleClickIocn"
      />

      <div class="main">
        <h2 class="tit">诚邀您投稿,下载论文模板</h2>
        <!-- <div class="obj-list"> -->
        <div
          class="obj-list"
          v-for="(item, i) in filelist"
          :key="i"
        >
          <div class="obj-item shadow">
            <div class="item-top">
              <h3 class="obj-tit">{{ item.filename }}</h3>
              <!-- <router-link
                :to="{ name: 'visitDetailPage', params: { pv: item } }"
                >下载</router-link
              > -->
              <el-button @click.stop="downloadTemplate(item)">下载模板</el-button> 
            </div>
            <!-- <div class="obj-info">
              {{ item.content }}
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import downHeader from "@/components/header"
  import { TreatiseReq } from "@/store/entity/treatisereq"
  import CurrentConferenceMixin from "@/mixin/CurrentConference"

  export default {
    name: "DownloadPaper",
    mixins: [CurrentConferenceMixin],
    components: {
      downHeader,
    },
    data() {
      return {
        headerConfig: {
          headerIcon: "city ct-xiangyou",
          headerTitle: "下载模板",
        },
        filelist: [],
      }
    },
    watch: {
      "currentConference.id": function (id, oldId) {
        if (id && id > 0) {
          this.getFileList()
        }
      },
    },
    created() {
      if (this.currentConference.id > 0) {
        this.getFileList()
      }
    },
    methods: {
      handleClickIocn() {
        history.go(-1)
      },
      async getFileList(conference_id) {
        const treatisereq = await TreatiseReq.getList(conference_id)
        this.filelist = treatisereq.file_metadata
      },
      async downloadTemplate(filestore){
        window.open(filestore.url);
      }
    },
  }
</script>

<style lang="scss" scoped>
  .main {
    width: 100%;
    padding: 0 15px;
    box-sizing: border-box;

    .tit {
      padding-left: 8px;
      margin-top: 30px;
      border-left: 4px solid var(--main-color);
      font-size: 16px;
      font-weight: bold;
      color: #424242;
    }

    .obj-list {
      padding-top: 15px;

      .obj-item {
        width: 100%;
        margin-top: 15px;
        padding: 15px;
        box-sizing: border-box;
        background: #fff;
        border-radius: 5px;

        .item-top {
          display: flex;
          justify-content: space-between;

          .obj-tit {
            color: var(--main-color);
            font-size: 20px;
          }

          a {
            color: var(--main-color);
            font-size: 12px;
          }
        }

        .obj-info {
          margin-top: 15px;
          line-height: 25px;
          color: #666;
        }
      }
    }
    .el-button {
      width: "100";
      margin-top: 5px;
      margin-left: 20px;
      color: var(--main-color);
    }
  }
</style>
